import * as St from '../styles';

export interface SegmentedOption<T extends string> {
  id: T;
  label: string;
  disabled?: boolean;
  /** Motivo exibido como dica quando a opção está desabilitada. */
  hint?: string;
}

interface SegmentedControlProps<T extends string> {
  options: SegmentedOption<T>[];
  value?: T;
  onChange: (value: T) => void;
}

function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
}: SegmentedControlProps<T>): JSX.Element {
  return (
    <St.Segmented role="group">
      {options.map((option) => (
        <St.SegmentedButton
          key={option.id}
          type="button"
          active={option.id === value}
          aria-pressed={option.id === value}
          disabled={option.disabled}
          title={option.disabled ? option.hint : undefined}
          onClick={() => onChange(option.id)}
        >
          {option.label}
        </St.SegmentedButton>
      ))}
    </St.Segmented>
  );
}

export default SegmentedControl;
